<template>
    <div class="main-content-container container-fluid  wiagro_configs">
        <div class="page-header row no-gutters py-3 mb-2">
            <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
                <span class="text-uppercase page-subtitle">{{$t('CONFIGS.CONFIGS')}}</span>
                <br/>
                <small>{{$t('CONFIGS.SUBTITLE')}}</small>
            </div>
        </div>

        <w-card size="100">
            <el-tabs v-model="activeName">
                <el-tab-pane :label="grain.showName" :name="grain.name" v-for="grain in grainTypes"
                             v-bind:key="grain.name">
                    <thresholdSliders :grain="grain.name" :title="$t('COMMON.TEMPERATURE')" type="temp"
                                      :onThresholdChange="onThresholdChange"/>
                    <thresholdSliders :grain="grain.name" :title="$t('COMMON.CO2')" type="co2"
                                      :onThresholdChange="onThresholdChange"/>
                    <!--<thresholdSliders :grain="grain.name" :title="$t('COMMON.HUMIDITY')" type="hum"
                                      :onThresholdChange="onThresholdChange"/>
                    -->
                    <thresholdSliders :grain="grain.name" :title="$t('COMMON.MOISTURE')" type="moisture"
                                      :onThresholdChange="onThresholdChange"/>
                </el-tab-pane>
            </el-tabs>
            <div class="row mt-md-4 mt-4">
                <div class="col-12 text-right">
                    <el-button type="primary" @click="save(activeName)">{{$t("COMMON.SAVE")}}</el-button>
                </div>
            </div>
        </w-card>


    </div>
</template>

<script>
    import wCard from "../components/common/wCard";
    import thresholdSliders from "../components/common/thresholdSliders";
    import api from "../utils/api/api";
    import unitConverter from "../utils/unitConverter";


    export default {
        name: "thresholdConfigs",
        data() {
            return {
                activeName: "soja",
                grainTypes: [{
                    name: "soja",
                    showName: this.$t('GRAIN.SOJA'),
                    thresholds: {}
                }, 
                {
                    name: "cebada",
                    showName: this.$t('GRAIN.CEBADA'),
                    thresholds: {}
                }, 
                {
                    name: "trigo",
                    showName: this.$t('GRAIN.TRIGO'),
                    thresholds: {}
                }, 
                {
                    name: "girasol",
                    showName: this.$t('GRAIN.GIRASOL'),
                    thresholds: {}
                }, 
                {
                    name: "centeno",
                    showName: this.$t('GRAIN.CENTENO'),
                    thresholds: {}
                }, 
                {
                    name: "maiz",
                    showName: this.$t('GRAIN.MAIZ'),
                    thresholds: {}
                }, 
                {
                    name: "poroto",
                    showName: this.$t('GRAIN.POROTO'),
                    thresholds: {}
                }, 
                {
                    name: "arroz",
                    showName: this.$t('GRAIN.ARROZ'),
                    thresholds: {}
                }
            ]
            };
        },

        components: {
            "w-card": wCard,
            thresholdSliders: thresholdSliders
        },
        methods: {
            onThresholdChange(grain, type, thresholds) {
                this.grainTypes.find(value => {
                    return value.name === grain;
                }).thresholds[type] = thresholds;
            },
            save(activeName) {
                let grainToSave = this.grainTypes.find(value => {
                    return value.name === activeName;
                });

                let grainObj = {
                    grain: activeName,
                    limits: {}
                };

                Object.keys(grainToSave.thresholds).forEach(type => {
                    grainObj.limits[type] = {status: []};
                    grainObj.limits[type]["status"] = [{
                        min_start: unitConverter.convertFrom(type, grainToSave.thresholds[type].B, this.$store.getters.unit(type)),
                        min_end: unitConverter.convertFrom(type, grainToSave.thresholds[type].C, this.$store.getters.unit(type)),
                        max_end: unitConverter.convertFrom(type, grainToSave.thresholds[type].C, this.$store.getters.unit(type)),
                        max_start: unitConverter.convertFrom(type, grainToSave.thresholds[type].B, this.$store.getters.unit(type)),
                        name: "OK",
                        number: 1
                    }, {
                        number: 2,
                        name: "WARN",
                        max_start: unitConverter.convertFrom(type, grainToSave.thresholds[type].C, this.$store.getters.unit(type)),
                        max_end: unitConverter.convertFrom(type, grainToSave.thresholds[type].D, this.$store.getters.unit(type)),
                        min_end: unitConverter.convertFrom(type, grainToSave.thresholds[type].B, this.$store.getters.unit(type)),
                        min_start: unitConverter.convertFrom(type, grainToSave.thresholds[type].A, this.$store.getters.unit(type)),
                    }, {
                        number: 3,
                        name: "CRIT",
                        max_end: unitConverter.convertFrom(type, grainToSave.thresholds[type].max, this.$store.getters.unit(type)),
                        max_start: unitConverter.convertFrom(type, grainToSave.thresholds[type].D, this.$store.getters.unit(type)),
                        min_start: unitConverter.convertFrom(type, grainToSave.thresholds[type].min, this.$store.getters.unit(type)),
                        min_end: unitConverter.convertFrom(type, grainToSave.thresholds[type].A, this.$store.getters.unit(type)),
                    }
                    ]
                });

                api.updateGrainAlertThresholds(grainObj).then(value => {
                    this.$message.success(this.$t('COMMON.SAVE_SUCCESS'))
                }).catch(reason => {
                    this.$message.success(this.$t('COMMON.SAVE_FAILURE'))

                });


            }
        }
    };
</script>

<style lang="scss">

</style>